<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('baPharmacy:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="药房名称">
                <a-input v-model="queryParam.pharmacyName" allow-clear placeholder="请输入药房名称" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="药房类型">
                <a-select v-model="queryParam.type" allow-clear placeholder="请选择药房类型" :options="type"></a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="是否支持物流配送">
                  <!-- <a-input v-model="queryParam.isDelivery" allow-clear placeholder="请输入是否支持物流配送(0-否1-是)"/> -->
                  <a-select v-model="queryParam.isDelivery" allow-clear placeholder="请选择是否支持物流配送" :options="isDelivery">
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否推荐">
                  <!-- <a-input v-model="queryParam.isRecom" allow-clear placeholder="请输入是否推荐"/> -->
                  <a-select v-model="queryParam.isRecom" allow-clear placeholder="请选择是否启用" :options="isRecom">
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否启用">
                  <!-- <a-input v-model="queryParam.useflag" allow-clear placeholder="请输入是否启用"/> -->
                  <a-select v-model="queryParam.useflag" allow-clear placeholder="请选择是否启用" :options="useflag">
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table ref="table" :columns="columns" :data="loadData" :alert="options.alert"
        :rowKey="(record) => record.pharmacyId" :rowSelection="options.rowSelection">

        <template class="table-operator" slot="operator">
          <a-button type="primary" icon="plus" @click="$refs.addForm.add({}, true,'添加药房')">添加药房</a-button>
        </template>

        <span slot="tyep" slot-scope="text, record">
          {{ record.tyep == 1 ? '内配' : record.tyep == 2 ? '外配' : '' }}
        </span>
        <span slot="isDelivery" slot-scope="text, record">
          {{ record.isDelivery == 0 ? '否' : record.isDelivery == 1 ? '是' : '' }}
        </span>
        <span slot="isRecom" slot-scope="text, record">
          {{ record.isRecom == 0 ? '否' : record.isRecom == 1 ? '是' : '' }}
        </span>
        <span slot="useflag" slot-scope="text, record">
          {{ record.useflag == 0 ? '否' : record.useflag == 1 ? '是' : '' }}
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="$refs.addForm.add(record, false,'查看详情')">查看</a>
          <a style="margin-left:8px" @click="$refs.addForm.add(record, true,'编辑详情')">编辑</a>
          <a-popconfirm v-if="hasPerm('baPharmacy:delete')" placement="topRight" title="确认删除？"
            @confirm="() => singleDelete(record)">
            <a style="margin-left:8px">删除</a>
          </a-popconfirm>
        </span>
      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import { baPharmacyPage, baPharmacyDelete, baPharmacyExport } from '@/api/modular/interhospital/bapharmacy/baPharmacyManage'
  import addForm from './addForm.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 检索状态栏参数
        type : [
          {
            value: '1',
            label: '内配',
          },
          {
            value: '2',
            label: '外配',
          },
        ],
        isDelivery : [
          {
            value: '0',
            label: '否',
          },
          {
            value: '1',
            label: '是',
          },
        ],
        isRecom : [
          {
            value: '0',
            label: '否',
          },
          {
            value: '1',
            label: '是',
          },
        ],
        useflag : [
          {
            value: '0',
            label: '否',
          },
          {
            value: '1',
            label: '是',
          },
        ],
        // 表头
        columns: [
          {
            title: '药房名称',
            align: 'center',
            dataIndex: 'pharmacyName',
            ellipsis : true,
          },
          {
            title: '类型',
            align: 'center',
            dataIndex: 'tyep',
            scopedSlots: { customRender: 'tyep' },
            ellipsis : true,
          },
          {
            title: '是否支持物流配送',
            align: 'center',
            dataIndex: 'isDelivery',
            scopedSlots: { customRender: 'isDelivery' },
            ellipsis : true,
          },
          {
            title: '是否推荐',
            align: 'center',
            dataIndex: 'isRecom',
            scopedSlots: { customRender: 'isRecom' },
            ellipsis : true,
          },
          {
            title: '电话',
            align: 'center',
            dataIndex: 'phone'
          },
          // {
          //   title: '所属地区省行政编码',
          //   align: 'center',
          //   dataIndex: 'regionProvinceCode'
          // },
          // {
          //   title: '所属地区市行政编码',
          //   align: 'center',
          //   dataIndex: 'regionCityCode'
          // },
          {
            title: '详细地址',
            align: 'center',
            dataIndex: 'addressDetail'
          },
          {
            title: '描述',
            align: 'center',
            dataIndex: 'pharmacyDesc'
          },
          {
            title: '是否启用',
            align: 'center',
            dataIndex: 'useflag',
            scopedSlots: { customRender: 'useflag' },
          }
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return baPharmacyPage(Object.assign(parameter, this.queryParam)).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      if (this.hasPerm('baPharmacy:edit') || this.hasPerm('baPharmacy:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = { 'pharmacyId': record.pharmacyId }
        this.baPharmacyDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'pharmacyId': d }
        })
        this.baPharmacyDelete(paramIds)
      },
      baPharmacyDelete (record) {
        baPharmacyDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'pharmacyId': d }
        })
        baPharmacyExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>
<style lang="less" scoped>
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
    
</style>
